import React from 'react';
import {
  Alert,
  AlertTitle,
  Skeleton,
  Stack,
} from '@mui/material';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { TeamMember, Traveler } from '@marageti/z4-sdk/lib/people';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import TripRequestDetailCard from '../../../trip-request-details/trip-request-card';
import { getChipsFromTripRequest } from '../../../../utils/chips';
import TripRequestDetailsSidebar from '../../../sidebars/trip-request-details-sidebar';

type InfoPanelViewProps = {
  error: ApiError | null;
  loggedInTeamMember: TeamMember | null;
  isLoading: boolean;
  isMobile: boolean;
  travelers: Traveler[] | undefined;
  tripRequest: TripRequest | undefined;
};

const InfoPanelView = ({
  error,
  loggedInTeamMember,
  isLoading,
  isMobile,
  travelers,
  tripRequest,
}: InfoPanelViewProps) => {
  if (error) {
    return (
      <Alert severity="error">
        <AlertTitle>
          There was an error loading trip information
        </AlertTitle>
        {error.message}
        {error.code && `Code: ${error.code} `}
        {error.id && `ID: ${error.id}`}
      </Alert>
    );
  }

  if (isLoading) {
    return <Skeleton variant="rounded" height={600} />;
  }

  if (isMobile && tripRequest) {
    return (
      <TripRequestDetailCard
        chips={getChipsFromTripRequest(tripRequest, true)}
        loggedInTeamMember={loggedInTeamMember}
        title={`${travelers?.[0]?.fullName}'s Trip`}
        titleTypographyProps={{
          variant: 'bodyBold',
        }}
        tripRequest={tripRequest}
      />
    );
  }

  if (!isMobile && tripRequest && travelers) {
    return (
      <Stack direction="column" spacing={3}>
        <TripRequestDetailsSidebar
          tripRequestId={tripRequest.id}
        />
      </Stack>
    );
  }

  return null;
};

export default InfoPanelView;
